// Client Configuration Mapping
// Each client has a unique ID and their own configuration

import log13 from '../components/enquiry/log13.png';
import mdtseLogo from '../components/enquiry/mdtse-logo.png';

const clientConfigs = {
  // IIFD Surat - Default Client
  'iifd-surat': {
    clientId: 'iifd-surat',
    clientName: 'IIFD Surat',
    templateType: 'template7', // Specifies which form template to use
    isClient: true, // Set to true to show only after admin login
    instituteId: 106336, // Single institute ID for all APIs
    // API Configuration
    api: {
      // Single Base URL for all APIs
      baseUrl: 'https://api.proctur.com',

      // Authorization tokens
      authorization: '989b4b56c7b5eae82687fb78c0d09d17ba2a2396200964c306cca453bbf2d100',
      areasApiAuth: 'MTQ3NTk0NXwwOjEyMzEyMzoxMDYyMTB8MzAwMDM=',

      // API Endpoints (all relative to baseUrl)
      endpoints: {
        // Form submission endpoint
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',

        // Cities endpoint - fetches cities by state
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=11',

        // Areas endpoint - requires areasApiAuth
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/{instituteId}?city_ids=210',

        // Courses endpoint - no authorization required
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },

      // Default form data
      defaults: {
        state: 'Gujarat',
        stateId: 5,
        city: 'Surat',
        defaultArea: 'Surat'
      }
    },
    contactInfo: {
      phone1: '9601336742',
      phone2: '7984434475',
      email: 'staffiifdsurat@gmail.com',
      website: 'iifdsurat.com',
      address: '3rd floor Riga street nr Rajhans Cosmic, G D Goenka road Vesu Canal road Surat'
    },
    branding: {
      logo: '/logo.webp',
      heroTitle: 'STUDENT REGISTRATION FORM',
      heroSubtitle: 'FASHION | INTERIOR | EVENT | SHORT TERM',
      badgeText: 'Premier Educational Institute',
      theme: {
        primaryColor: '#dc2626',
        secondaryColor: '#991b1b'
      }
    },
    stats: {
      alumni: '10000+',
      experience: '15+',
      placement: '100%',
      partners: '200+'
    },
    features: [
      'Industry-expert design faculty',
      '100% placement assistance',
      'Industry internships & projects',
      'Global design certifications'
    ],
    courses: [
    ]
  },

  // Demo Institute - Modern Template
  'demo-institute': {
    clientId: 'demo-institute',
    clientName: 'Demo Institute',
    templateType: 'template8',
    isClient: true, // Set to true to show only after admin login
    instituteId: 101985, // Single institute ID for all APIs
    // API Configuration
    api: {
      // Single Base URL for all APIs
      baseUrl: 'https://api.proctur.com',

      // Authorization tokens
      authorization: 'your_auth_token_here',
      areasApiAuth: 'your_areas_auth_token_here',

      // API Endpoints (all relative to baseUrl)
      endpoints: {
        // Form submission endpoint
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',

        // Cities endpoint - fetches cities by state
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=1',

        // Areas endpoint - requires areasApiAuth
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/999999?city_ids=1',

        // Courses endpoint - no authorization required
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },

      // Default form data
      defaults: {
        state: 'Uttar Pradesh',
        stateId: 1,
        city: 'Basti',
        defaultArea: 'Hariay'
      }
    },
    contactInfo: {
      phone1: '1234567890',
      phone2: '0987654321',
      email: 'info@demoinstitute.com',
      website: 'demoinstitute.com',
      address: 'Demo Address, City, State'
    },
    branding: {
      logo: '/demo-logo.svg',
      heroTitle: 'ADMISSION FORM',
      heroSubtitle: 'Transform Your Future With Quality Education',
      badgeText: 'Top Ranked Institute',
      theme: {
        primaryColor: '#2563eb',
        secondaryColor: '#1e40af'
      }
    },
    stats: {
      alumni: '5000+',
      experience: '10+',
      placement: '95%',
      partners: '100+'
    },
    features: [
      'Expert Faculty',
      'Placement Support',
      'Industry Exposure',
      'Modern Infrastructure'
    ],
    courses: [
      'Diploma in Fashion Design',
      'Diploma in Interior Design',
      'Certificate Programs'
    ]
  },

  // Coaching Center Example
  'coaching-demo': {
    clientId: 'coaching-demo',
    clientName: 'Bright Future Coaching',
    templateType: 'template9',
    isClient: true, // Set to true to show only after admin login
    instituteId: 101985, // Single institute ID for all APIs
    // API Configuration
    api: {
      // Single Base URL for all APIs
      baseUrl: 'https://api.proctur.com',

      // Authorization tokens
      authorization: 'your_auth_token_here',
      areasApiAuth: 'your_areas_auth_token_here',

      // API Endpoints (all relative to baseUrl)
      endpoints: {
        // Form submission endpoint
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',

        // Cities endpoint - fetches cities by state
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=1',

        // Areas endpoint - requires areasApiAuth
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/999999?city_ids=1',

        // Courses endpoint - no authorization required
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },

      // Default form data
      defaults: {
        state: 'Uttar Pradesh',
        stateId: 1,
        city: 'Basti',
        defaultArea: 'Hariay'
      }
    },
    contactInfo: {
      phone1: '9876543210',
      phone2: '9876543211',
      email: 'info@brightfuturecoaching.com',
      website: 'brightfuturecoaching.com',
      address: '123 Learning Street, Education Hub, Surat'
    },
    branding: {
      logo: '/coaching-logo.svg',
      heroTitle: 'Bright Future Coaching',
      heroSubtitle: 'Achieve Your Goals with Expert Guidance',
      badgeText: 'Top Rated Coaching Center',
      theme: {
        primaryColor: '#f5576c',
        secondaryColor: '#f093fb'
      }
    },
    stats: {
      alumni: '3000+',
      experience: '8+',
      placement: '98%',
      partners: '50+'
    },
    features: [
      'Small Batch Sizes',
      'Personalized Attention',
      'Regular Tests & Assessments',
      'Experienced Faculty',
      'Study Material Included'
    ],
    courses: [
      'JEE Mains & Advanced',
      'NEET Preparation',
      'Class 11-12 Science',
      'Class 11-12 Commerce',
      'Foundation Course (Class 8-10)',
      'Olympiad Preparation'
    ]
  },

  // College Example
  'college-demo': {
    clientId: 'college-demo',
    clientName: 'Excellence College of Arts & Science',
    templateType: 'template10',
    isClient: true, // Set to true to show only after admin login
    instituteId: 101985, // Single institute ID for all APIs
    // API Configuration
    api: {
      // Single Base URL for all APIs
      baseUrl: 'https://api.proctur.com',

      // Authorization tokens
      authorization: 'your_auth_token_here',
      areasApiAuth: 'your_areas_auth_token_here',

      // API Endpoints (all relative to baseUrl)
      endpoints: {
        // Form submission endpoint
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',

        // Cities endpoint - fetches cities by state
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=1',

        // Areas endpoint - requires areasApiAuth
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/999999?city_ids=1',

        // Courses endpoint - no authorization required
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },

      // Default form data
      defaults: {
        state: 'Uttar Pradesh',
        stateId: 1,
        city: 'Basti',
        defaultArea: 'Hariay'
      }
    },
    contactInfo: {
      phone1: '9123456789',
      phone2: '9123456788',
      email: 'admissions@excellencecollege.edu',
      website: 'excellencecollege.edu',
      address: 'College Campus, University Road, Surat - 395007'
    },
    branding: {
      logo: '/college-logo.svg',
      heroTitle: 'Excellence College',
      heroSubtitle: 'Empowering Minds, Shaping Futures',
      badgeText: 'NAAC A+ Accredited',
      theme: {
        primaryColor: '#3b82f6',
        secondaryColor: '#1e3a8a'
      }
    },
    stats: {
      alumni: '8000+',
      experience: '12+',
      placement: '92%',
      partners: '150+'
    },
    features: [
      'State-of-the-art Infrastructure',
      'Experienced Faculty',
      'Industry Partnerships',
      'Research Opportunities',
      'Sports & Cultural Activities',
      'Scholarship Programs'
    ],
    courses: [
      'B.Sc. Computer Science',
      'B.Sc. Information Technology',
      'B.Com - Accounting & Finance',
      'B.Com - Banking & Insurance',
      'B.A. English Literature',
      'B.A. Psychology',
      'BBA - Business Administration',
      'BCA - Computer Applications'
    ]
  },

  // University Example
  'university-demo': {
    clientId: 'university-demo',
    clientName: 'National University of Advanced Studies',
    templateType: 'template11',
    isClient: true, // Set to true to show only after admin login
    instituteId: 101985, // Single institute ID for all APIs
    // API Configuration
    api: {
      // Single Base URL for all APIs
      baseUrl: 'https://api.proctur.com',

      // Authorization tokens
      authorization: 'your_auth_token_here',
      areasApiAuth: 'your_areas_auth_token_here',

      // API Endpoints (all relative to baseUrl)
      endpoints: {
        // Form submission endpoint
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',

        // Cities endpoint - fetches cities by state
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=1',

        // Areas endpoint - requires areasApiAuth
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/999999?city_ids=1',

        // Courses endpoint - no authorization required
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },

      // Default form data
      defaults: {
        state: 'Uttar Pradesh',
        stateId: 1,
        city: 'Basti',
        defaultArea: 'Hariay'
      }
    },
    contactInfo: {
      phone1: '9988776655',
      phone2: '9988776656',
      email: 'admissions@nuas.edu.in',
      website: 'nuas.edu.in',
      address: 'University Campus, Knowledge Park, Surat - 395009, Gujarat, India'
    },
    branding: {
      logo: '/university-logo.svg',
      heroTitle: 'National University',
      heroSubtitle: 'Excellence in Education, Research & Innovation',
      badgeText: 'UGC Approved | NAAC A++ | NIRF Ranked',
      theme: {
        primaryColor: '#1a1f36',
        secondaryColor: '#c9a961'
      }
    },
    stats: {
      alumni: '25000+',
      experience: '25+',
      placement: '95%',
      partners: '500+'
    },
    features: [
      'World-class Faculty with PhD Qualifications',
      'International Collaborations & Exchange Programs',
      'Cutting-edge Research Facilities',
      'Industry-Integrated Curriculum',
      'Comprehensive Placement Support',
      'Entrepreneurship Development Cell',
      'State-of-the-art Libraries & Labs',
      'Residential Campus with Modern Amenities'
    ],
    courses: [
      'B.Tech - Computer Science & Engineering',
      'B.Tech - Mechanical Engineering',
      'B.Tech - Electronics & Communication',
      'B.Tech - Civil Engineering',
      'MBA - Marketing & Finance',
      'MBA - Human Resources',
      'M.Tech - Data Science',
      'M.Tech - Artificial Intelligence',
      'M.Sc. - Physics',
      'M.Sc. - Chemistry',
      'Ph.D. Programs (All Disciplines)',
      'Executive Education Programs'
    ]
  },

  // IIFD Surat Modern - App Style Template
  'iifd-surat-modern': {
    clientId: 'iifd-surat-modern',
    clientName: 'IIFD Surat',
    templateType: 'template12', // Modern app-style template
    isClient: true, // Set to false to show in public gallery
    instituteId: 106336,
    api: {
      baseUrl: 'https://api.proctur.com',
      authorization: '989b4b56c7b5eae82687fb78c0d09d17ba2a2396200964c306cca453bbf2d100',
      areasApiAuth: 'MTQ3NTk0NXwwOjEyMzEyMzoxMDYyMTB8MzAwMDM=',
      endpoints: {
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=5',
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/{instituteId}?city_ids=210',
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },
      defaults: {
        state: 'Gujarat',
        stateId: 5,
        city: 'Surat',
        defaultArea: 'Surat'
      }
    },
    contactInfo: {
      phone1: '9601336742',
      phone2: '7984434475',
      email: 'staffiifdsurat@gmail.com',
      website: 'iifdsurat.com',
      address: '3rd floor Riga street nr Rajhans Cosmic, G D Goenka road Vesu Canal road Surat'
    },
    branding: {
      logo: '/logo.webp',
      heroTitle: 'Welcome to IIFD Surat',
      heroSubtitle: 'Fashion | Interior | Event | Short Term Programs',
      badgeText: 'Premier Design Institute',
      theme: {
        primaryColor: '#dc2626',
        secondaryColor: '#991b1b'
      }
    },
    stats: {
      alumni: '10000+',
      experience: '15+ Years',
      placement: '100%',
      partners: '200+'
    },
    features: [
      'Industry-expert design faculty',
      '100% placement assistance',
      'Industry internships & projects',
      'Global design certifications',
      'Modern studio facilities',
      'Portfolio development support'
    ],
    courses: []
  },

  // IIG Mumbai - Simple Enquiry Form
  'iig-mumbai': {
    clientId: 'iig-mumbai',
    clientName: 'IIG Mumbai',
    templateType: 'template14',
    isClient: true,
    instituteId: 106348,
    api: {
      baseUrl: 'https://api.proctur.com',
      authorization: '375638e1d7960d2a5fc52871a3ecbccad34427c19a99a123f8b87fbfd100ca68',
      areasApiAuth: 'MTQ3NTk0NXwwOjEyMzEyMzoxMDYyMTB8MzAwMDM=',
      endpoints: {
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=11',
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/{instituteId}?city_ids=210',
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },
      defaults: {
        state: 'Maharashtra',
        stateId: 11,
        city: 'Mumbai',
        defaultArea: 'Mumbai'
      }
    },
    contactInfo: {
      phone1: '+91 9876543210',
      phone2: '+91 9876543211',
      email: 'info@iigmumbai.com',
      website: 'iigmumbai.com',
      address: 'IIG Mumbai, Andheri West, Mumbai, Maharashtra 400053'
    },
    branding: {
      logo: '/logo.webp',
      heroTitle: 'Welcome to IIG Mumbai',
      heroSubtitle: 'Excellence in Business Education',
      badgeText: 'Premier Business Institute',
      theme: {
        primaryColor: '#2563eb',
        secondaryColor: '#1e40af'
      }
    },
    stats: {
      alumni: '5000+',
      experience: '10+ Years',
      placement: '95%',
      partners: '100+'
    },
    features: [
      'Industry-expert faculty',
      'Placement assistance',
      'Industry internships',
      'Global certifications'
    ],
    courses: [
      'MBA',
      'PGDM',
      'BBA',
      'Executive MBA'
    ],
    areaOfInterestOptions: [
      'Management',
      'Marketing',
      'Finance',
      'Human Resources',
      'Operations',
      'Business Analytics',
      'Entrepreneurship'
    ],
    preferModeOptions: [
      'Online',
      'Offline',
      'Hybrid'
    ],
    preferTimeOptions: [
      'Morning (9 AM - 12 PM)',
      'Afternoon (12 PM - 4 PM)',
      'Evening (4 PM - 8 PM)'
    ]
  },

  // UWILL Classes - Student Admission Form
  'uwill': {
    clientId: 'uwill',
    clientName: 'UWILL Classes',
    templateType: 'template15',
    isClient: true,
    instituteId: 100174,
    api: {
      baseUrl: 'https://api.proctur.com',
      authorization: '2326e277d4d301eca9ddfbed26bd603b50b1247f0ee8202e414691929988b9a2',
      areasApiAuth: '2326e277d4d301eca9ddfbed26bd603b50b1247f0ee8202e414691929988b9a2',
      endpoints: {
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=1',
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/999999?city_ids=1',
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all',
        getStandards: '/StdMgmtWebAPI/api/v1/standards/all/{instituteId}'
      },
      defaults: {
        state: 'Gujarat',
        stateId: 5,
        city: 'Surat',
        defaultArea: 'Surat'
      }
    },
    contactInfo: {
      phone1: '8000770404',
      phone2: '9876543211',
      email: 'info@uwillclasses.com',
      website: 'uwillclasses.com',
      address: 'O.P. ROAD, 204 & 301 Turning Point Complex, Nr. ABS Tower, O.P. Road, Vadodara. (Guj.) – INDIA'
    },
    branding: {
      logo: 'https://uwillclasses.com/wp-content/uploads/2020/11/u-will-logo-hight-76-pixels.png',
      heroTitle: 'UWILL Classes',
      heroSubtitle: 'Empowering Students for a Brighter Future',
      badgeText: 'Trusted Education Partner',
      theme: {
        primaryColor: '#072949',
        secondaryColor: '#FFC600'
      }
    },
    stats: {
      alumni: '5000+',
      experience: '10+',
      placement: '95%',
      partners: '100+'
    },
    features: [
      'Expert Faculty & Mentors',
      'Comprehensive Study Material',
      'Regular Tests & Assessments',
      'Individual Attention',
      'Result-Oriented Teaching',
      'Career Guidance & Support'
    ],
    courses: []
  },

  // MD Group of Education, Chirawa - MDTSE 2026 scholarship exam landing page
  'mdtse': {
    clientId: 'mdtse',
    clientName: 'MD Group of Education',
    templateType: 'template16',
    isClient: true,
    // ERP institute id, confirmed by the register API response
    // ("institute_id": 106511, "institute_name": "M D Group Of Education").
    // Note the online test platform uses a different id - its token MTA2NTEw
    // is base64 of "106510".
    instituteId: 106511,
    api: {
      // Student registration. Both endpoints below sit behind the institute
      // auth filter - without a valid token the API returns a generic 500,
      // and with an invalid one it returns 404 "Institute not found".
      // Note this is the ERP token; the online test platform below uses its own.
      baseUrl: 'https://api.proctur.com',
      authorization: 'e0327e81f425a46741e4bbca7e8a0fbc2c4215314957fe93682a639cbb34e2bb',
      areasApiAuth: 'e0327e81f425a46741e4bbca7e8a0fbc2c4215314957fe93682a639cbb34e2bb',
      endpoints: {
        // Sends the login OTP to the student's mobile, then creates the account.
        generateOtp: '/StdMgmtWebAPI/api/v2/user/login/generate_otp',
        registerUser: '/StdMgmtWebAPI/api/v2/user/register'
      },
      // Online test platform - standards and test (exam category) lists.
      // Switch baseUrl to https://onlinetestsitapi.proctur.com for SIT.
      onlineTest: {
        baseUrl: 'https://exdapi.proctur.com',
        // base64 of "106511" - the client's real institute id.
        authorization: 'MTA2NTEx',
        endpoints: {
          getStandards: '/v1/admin/standards/list',
          getTests: '/v1/tests/standards/{standardId}'
        }
      },
      defaults: {
        state: 'Rajasthan',
        stateId: 27,
        city: 'Jhunjhunu',
        defaultArea: 'Chirawa'
      }
    },
    contactInfo: {
      phone1: '8107859351',
      phone2: '7222888803',
      phone3: '8432644113',
      email: 'mdscrw@gmail.com',
      website: 'www.mdschoolcrw.com',
      website2: 'www.mdcl.in',
      loginUrl: 'https://login.mdtse.com/',
      address: 'MD Campus, Jhunjhunu Road, Chirawa, Rajasthan'
    },
    branding: {
      logo: mdtseLogo,
      favicon: '/mdtse-logo.png',
      pageTitle: 'MDTSE Registration Form',
      heroTitle: 'MD Talent Search Exam 2026',
      heroSubtitle: 'A national-level scholarship test for Class VI to XII students - win up to 100% scholarship on NEET, JEE and Foundation courses, plus cash awards and topper recognition.',
      badgeText: 'MDCL | IIT-JEE | NEET-UG',
      theme: {
        primaryColor: '#9b1c1e',
        secondaryColor: '#12294f'
      }
    },
    stats: {
      alumni: '10000+',
      experience: '3rd Edition',
      placement: '100%',
      partners: '125 Lakh+'
    },
    features: [
      'Expert Faculty Guidance',
      'Comprehensive Study Material',
      'Personalized Mentorship',
      'Chapter-wise Test Series',
      'Proven Results Every Year',
      'Full Board Exam Support by MDCL Teachers'
    ],
    courses: []
  },

  // IIFD Surat Clean - App Style Template (No Banner, Stats, Features)
  'prayaas-education': {
    clientId: 'PRAYAAS Education',
    clientName: 'PRAYAAS Education',
    templateType: 'template13', // Clean modern template
    isClient: true, // Set to false to show in public gallery
    instituteId: 106348,
    api: {
      baseUrl: 'https://api.proctur.com',
      authorization: '375638e1d7960d2a5fc52871a3ecbccad34427c19a99a123f8b87fbfd100ca68',
      areasApiAuth: 'MTQ3NTk0NXwwOjEyMzEyMzoxMDYyMTB8MzAwMDM=',
      endpoints: {
        submitForm: '/StdMgmtWebAPI/api/v1/extLeads/website',
        getCities: '/StdMgmtWebAPI/api/v1/country/city?state_ids=5',
        getAreas: '/StdMgmtWebAPI/api/v1/cityArea/area/{instituteId}?city_ids=210',
        getCourses: '/StdMgmtWebAPI/api/v1/courseMaster/fetch/{instituteId}/all'
      },
      defaults: {
        state: 'Gujarat',
        stateId: 5,
        city: 'Surat',
        defaultArea: 'Surat'
      }
    },
    contactInfo: {
      phone1: '+91 7378743031',
      phone2: '+91 7767073031',
      email: 'prayaas.edu2024@gmail.com',
      website: '',
      address: '2nd Floor, Loan Center, Sterling Plaza, CTS No. 1262/B, Plot No. 594B Office No. 301A, 301, Jangali Maharaj Rd, above AXIS BANK, Pune, Maharashtra 411004'
    },
    branding: {
      logo: log13,
      heroTitle: 'Welcome to PRAYAAS Education',
      heroSubtitle: 'Dedicated to transforming education for holistic development',
      badgeText: 'Premier Education Institute',
      theme: {
        primaryColor: '#dc2626',
        secondaryColor: '#991b1b'
      }
    },
    stats: {
      alumni: '10000+',
      experience: '15+ Years',
      placement: '100%',
      partners: '200+'
    },
    features: [
      'Industry-expert design faculty',
      '100% placement assistance',
      'Industry internships & projects',
      'Global design certifications',
      'Modern studio facilities',
      'Portfolio development support'
    ],
    courses: []
  }
};

// Helper function to check if client ID is valid
export const isValidClientId = (clientId) => {
  return clientConfigs.hasOwnProperty(clientId);
};

// Helper function to get client config by ID
export const getClientConfig = (clientId) => {
  return clientConfigs[clientId] || null;
};

// Helper function to get all client IDs
export const getAllClientIds = () => {
  return Object.keys(clientConfigs);
};

// Helper function to build API URL
export const getApiUrl = (clientConfig, endpointKey) => {
  const baseUrl = clientConfig.api.baseUrl;
  const endpoint = clientConfig.api.endpoints[endpointKey];

  // Replace {instituteId} placeholder with actual instituteId
  const finalEndpoint = endpoint.replace('{instituteId}', clientConfig.instituteId);

  return `${baseUrl}${finalEndpoint}`;
};

export default clientConfigs;
